import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper } from 'Components/UI'
import { Image, Text } from 'Components/UI/_Legacy'

import { Container, Content, Dash, ImageHolder } from './styles'

function Description({ data }) {
  if (!data) return null

  return (
    <Container>
      <Wrapper
        alignItems={['center', 'center', 'center', 'flex-start']}
        flexDirection={['column', 'column', 'column', 'row']}
        width={1}
      >
        <ImageHolder>
          {/* 268px holder minus its padding — the logo never renders wider
              than ~204px. */}
          <Image
            alt=""
            height={200}
            image={data?.logo}
            lazy
            sizes="204px"
            width={200}
          />
        </ImageHolder>

        <Content>
          <Text as="h1" fontSize={[20, 32]} legacyTitle letterSpacing={1.5}>
            {data?.title}
          </Text>
          <Dash my={16} />
          <Text body light>
            {data?.text}
          </Text>
        </Content>
      </Wrapper>
    </Container>
  )
}

Description.defaultProps = {
  data: {},
}

Description.propTypes = {
  data: PropTypes.object,
}

export default Description
